'use client';

import { resolveSubscriptionStatus } from '@/app/lib/actions/payment-result-actions';
import { ENDPOINTS } from '@/app/lib/constants/endpoints';
import { useAppDispatch, useAppSelector } from '@/app/lib/store/hooks';
import { setUser } from '@/app/lib/store/user-slice';
import { useEffect, useRef } from 'react';
import { fetchUserClientData } from '@/app/lib/services/session-service';
import { setPaymentStatus } from '@/app/lib/store/payment-status-slice';
import { PaymentStatus } from '@prisma/client';
import { configEndpoint } from '@/app/lib/utils/api-utils';

export default function PaymentStatusChecker() {
  const status = useAppSelector(state => state.payment.status);
  const dispatch = useAppDispatch();

  const receivedFinalStatus = useRef(false);

  useEffect(() => {
    if (receivedFinalStatus.current || !status) return;

    const interval = setInterval(async () => {
      const endpoint = configEndpoint(ENDPOINTS.checkPaymentStatus);

      const res = await fetch(endpoint, { method: 'POST' });
      const { paymentStatus } = await res.json();

      if (paymentStatus && paymentStatus !== PaymentStatus.PENDING) {
        dispatch(setPaymentStatus(paymentStatus));
        clearInterval(interval); // Останавливаем polling
        receivedFinalStatus.current = true;
      }
    }, 3000); // Период: 3 секунды

    return () => clearInterval(interval);
  }, [status, dispatch]);

  useEffect(() => {
    if (!status || status === PaymentStatus.PENDING) return;

    const handleSubscriptionStatus = async () => {
      await resolveSubscriptionStatus(status);

      const userWithUpdatedSubscription = await fetchUserClientData();
      dispatch(setUser(userWithUpdatedSubscription));
    };

    handleSubscriptionStatus();
  }, [status, dispatch]);

  return null;
}
